/* src/@theme/menu-horizontal/menu-horizontal.component.scss */
.themed_items {
  color: #646c9a !important;
}
/*# sourceMappingURL=menu-horizontal.component.css.map */
